module.exports = __webpack_public_path__ + "static/paris-015.thumb-033f7098adc9e971fee2b58f5948999e.jpg";